import React, { useEffect, useState } from "react";
import Dialog from "../../common/ConfirmDialog.jsx";
import LoadingIndicator from "../../common/loading_indicator.jsx";

import { project_report_list_batch_projects_json_path } from '~/routes';

const ReviewConfirmDialog = ({ decision, projectReportId, reportPhaseId, ...rest }) => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  const proceedAsReviewed = decision == "proceed_as_reviewed";

  useEffect(() => {
    if (proceedAsReviewed) {
      jQuery.getJSON(
        project_report_list_batch_projects_json_path({
          report_phase_id: reportPhaseId,
          project_report_id: projectReportId,
        }),
        (data) => {
          setProjects(data);
          setLoading(false);
        }
      );
    } else {
      setLoading(false);
    }
  }, [reportPhaseId, projectReportId, proceedAsReviewed]);

  const approvedProjects = projects.filter((p) => p.review_approved);
  const rejectedProjects = projects.filter((p) => !p.review_approved);

  return (
    <Dialog
      title={I18n.t(`confirm_submit_review_${decision}`)}
      addText={I18n.t(`submit_review_as_${decision}`)}
      closeText={I18n.t("cancel")}
      {...rest}
    >
      {loading ? (
        <LoadingIndicator />
      ) : proceedAsReviewed ? (
        <>
          {approvedProjects.length && rejectedProjects.length ? (
            <div className="alert alert-info">{I18n.t("batch_clone_warning")}</div>
          ) : null}
          {approvedProjects.length ? (
            <>
              <p>
                {I18n.t("review_proceed_as_reviewed_description_1")}
                <b>{I18n.t("review_status_approved")}</b>
                {I18n.t("review_proceed_as_reviewed_description_2")}
              </p>
              <ul>
                {approvedProjects.map((p) => (
                  <li key={p.label}>{p.label}</li>
                ))}{" "}
              </ul>
            </>
          ) : null}
          {rejectedProjects.length ? (
            <>
              <p>
                {I18n.t("review_proceed_as_reviewed_description_1")}
                <b>{I18n.t("review_status_rejected")}</b>
                {I18n.t("review_proceed_as_reviewed_description_2")}
              </p>
              <ul>
                {rejectedProjects.map((p) => (
                  <li key={p.label}>{p.label}</li>
                ))}{" "}
              </ul>
            </>
          ) : null}
          <br />
          <p>{I18n.t("proceed_as_reviewed_confirmation")}</p>
        </>
      ) : (
        <p>
          {I18n.t("confirm_submit_review_1")} <b>{I18n.t(`submit_review_as_${decision}`)}</b>{" "}
          {I18n.t("confirm_submit_review_2")}
        </p>
      )}
    </Dialog>
  );
};

const ConfirmDialog = ({ isReview, ...rest }) => {
  if (isReview) return <ReviewConfirmDialog {...rest} />
  return <FillConfirmDialog {...rest} />;
}; 

const FillConfirmDialog = ({ ...rest }) => {
  return (
    <Dialog
      title={I18n.t("confirm_submit_report")}
      addText={I18n.t("submit")}
      closeText={I18n.t("cancel")}
      {...rest}
    >
      <p>{I18n.t("submit_report_confirmation_description")}</p>
    </Dialog>
  );
};

export default ConfirmDialog;
